import styled from 'styled-components';

export const StyledAction = styled.div`
  align-self: center;
  margin-left: auto;
`;
export const StyledIconAndText = styled.div`
  display: flex;
  gap: 0.5rem;
`;
